// extracted by mini-css-extract-plugin
export default {"main":"TableHeader_main__9QyKq","actions":"TableHeader_actions__Ud8Di","title":"TableHeader_title__msUH9"};